// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.navbar-item.is-active[data-v-7ba5bd90] {\n  font-weight: 500;\n  background-color: #fafafa !important;\n}\n", ""]);
// Exports
module.exports = exports;
